import { Button, Form, Input, Select, message, Space } from "antd";
import { serverFetch } from "../../server";
import { useState, useEffect } from "react";
import { isMobile } from "../../extensions/design";

const ClientAbonUsageChange = ({ usage, onClose, vid, executorUsers, finish }) => {
const [form] = Form.useForm();
const [loading, setLoading] = useState(false);
const [usageItems, setUsageItems] = useState(usage);
const [localExecutorUsers, setLocalExecutorUsers] = useState(executorUsers);

  // Эффект для обработки отсутствующего пользователя в списке
  useEffect(() => {
    if (!executorUsers) {
      setLocalExecutorUsers([]);
      return;
    }

    const savedUserId = usage?.userId;
    if (savedUserId != null && !executorUsers.some(u => u.value === savedUserId)) {
      // Если пользователя нет в списке, запрашиваем его отдельно
      serverFetch("User/" + savedUserId)
        .then(u => {
          if (u && u.id != null) {
            setLocalExecutorUsers([
              { value: u.id, label: u.name, disabled: true }, 
              ...executorUsers
            ]);
          } else {
            // Фолбэк, если API не вернуло пользователя, но в usage есть userName
            const fallbackLabel = usage?.userName;
            setLocalExecutorUsers([
              { value: savedUserId, label: fallbackLabel, disabled: true }, 
              ...executorUsers
            ]);
          }
        })
        .catch(e => {
          message.error(e.userMessage);
          // Фолбэк при ошибке запроса
          const fallbackLabel = usage?.userName;
          setLocalExecutorUsers([
            { value: savedUserId, label: fallbackLabel, disabled: true }, 
            ...executorUsers
          ]);
        });
    } else {
      // Иначе просто используем переданные опции
      setLocalExecutorUsers(executorUsers);
    }
  }, [usage, executorUsers]);

  const onSave = () => {
    setLoading(true);
    serverFetch("sale/Use", { method: usage.id ? "PUT" : "POST", bodyData: usageItems })
      .then(() => {
        onClose(true);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  const onCancel = () => { onClose(usageItems) };

  useEffect(() => {
    form.setFieldsValue(usage);
    setUsageItems(usage)
  }, [usage]);

  const onValuesChange = value => setUsageItems({...usageItems, ...value});

  return !isMobile ?
    <Form form={form} colon={false} labelCol={{ span: 5 }} wrapperCol={{ span: 24 }} loading={loading} onValuesChange={onValuesChange} disabled={!!finish}>
      <Form.Item label="Количество" name="qty" wrapperCol={{ span: 4 }}><Input disabled={!!finish} /></Form.Item>
      <Form.Item label="Исполнитель" name="userId" wrapperCol={{ span: 24 }}><Select options={localExecutorUsers} disabled={vid === 0 || vid === 4 || !!finish}/></Form.Item>
      <Form.Item label=" " labelCol={{ span: 16 }} style={{marginTop:"16px", marginBottom:"16px"}}>
        <Space>
          <Button onClick={onSave} disabled={!!finish}>Сохранить</Button>
          <Button onClick={onCancel}>Отмена</Button>
        </Space>
      </Form.Item>
    </Form>
    :
    <Form form={form} layout="inline" colon={false} labelCol={{ flex: "100px" }} wrapperCol={{ flex: "1" }} className="client-subitem-content" loading={loading} onValuesChange={onValuesChange}>
      <Form.Item label="Количество" name="qty" style={{width:"100%"}}><Input disabled={!!finish} /></Form.Item>
      <Form.Item label="Исполнитель" name="userId" className="client-abon-form-item-with-margin"><Select style={{width:"100%"}} options={localExecutorUsers} disabled={vid === 0 || vid === 4 || !!finish}/></Form.Item>
      <Button style={{width: "49%", marginRight: "2%", marginTop: 6}}onClick={onSave} disabled={!!finish}>Сохранить</Button>
      <Button style={{width: "49%", marginTop: 6}} onClick={onCancel}>Отмена</Button>
    </Form>
};
export default ClientAbonUsageChange;
